import React from 'react';
import MemoryGamePage from '../pages/MemoryGamePage/MemoryGamePage';

export const MemoryGame = () => <MemoryGamePage />;
